import { GridValidRowModel } from "@mui/x-data-grid-pro";
//MUZUN;454081;07042025
const MedicalUnits : GridValidRowModel[] = [
    {
      id: 1,
      drugType: "07.03.2025",
      suspectedDrugName: "Sinerji Bilişim",
      routeofDrug: "Sinerji Bijişim",
      dailyDose: "",
      startDate: "07.03.2025 17:11:51",
      endDate: "07.03.2025 17:11:51",
      indication: "",
      nurse: "Hemşire Ad",
      edit: "",
      delete: ""
    },
  ];

  export default MedicalUnits;